import { Flex } from '@chakra-ui/react';
import { Card } from 'components/UI';

type ParamEdit = {
  children?: React.ReactNode;
};

const ParameterEditSection = ({ children }: ParamEdit) => (
  <Card>
    <Flex
      sx={{
        p: 3.5,
        gap: 2.5,
        flex: 1,
        flexDir: 'column',
        justifyContent: 'stretch',
      }}
    >
      {children}
    </Flex>
  </Card>
);

export default ParameterEditSection;
